var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.to},nativeOn:{"click":function($event){return _vm.$emit('click')}}},[_c('button',{class:("btn btn-" + _vm.variant)},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }